import { useEffect } from 'react';

import { useChatClient } from '@bizzabo/chat-core';

const useMessagesTabNotifications = () => {
    const { client } = useChatClient();

    useEffect(() => {
        if (!client) {
            return;
        }

        const originalTitle = document.title;
        let notificationTitle = '';
        let interval: ReturnType<typeof setInterval>;

        const handleVisibilityChange = () => {
            let listener;

            if (document.hidden) {
                listener = client.on(event => {
                    const isPrivateChannel = event.channel_type === 'private';
                    const isNewMessageEvent =
                        event.type === 'notification.message_new' || event.type === 'message.new';
                    const isMessageFromAdmin = event.message?.user.id === 'bizzabo_admin';

                    if (isPrivateChannel && isNewMessageEvent && !isMessageFromAdmin) {
                        if (document.hidden) {
                            notificationTitle = `${event.message?.user.firstName} messages you`;
                            document.title = notificationTitle;
                        }
                    }
                });

                interval = setInterval(() => {
                    if (document.hidden && notificationTitle) {
                        document.title =
                            document.title !== originalTitle ? originalTitle : notificationTitle;
                    }
                }, 1000);
            } else {
                listener?.unsubscribe();
                resetTitle();
            }
        };

        const resetTitle = () => {
            notificationTitle = '';
            document.title = originalTitle;
            clearInterval(interval);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            resetTitle();
        };
    }, [client]);
};

export default useMessagesTabNotifications;
